import React from 'react';
import './AboutPage.css';
import CooperativeBrands from '../components/CooperativeBrands';

const AboutPage = () => {

  return (
    <div className="about-page">
      <div className="container">
        <div className="page-header">
          <h1>公司介绍</h1>
          <p>北京灵动无界科技有限公司 - 领先的前沿科技产品服务商</p>
        </div>

        <section className="company-intro">
          <div className="intro-content">
            <h2>公司简介</h2>
            <p>
              北京灵动无界科技有限公司是一家前沿科技创新企业，围绕机电、控制、人工智能、机器人、电子信息等核心学科领域，全力投身本科工程教育及现代职业教育改革创新实验平台的研发；深度聚焦最新技术科研方向，为高校及科研机构提供契合各学科研究的科研支撑平台；精准对接新技术产业应用，积极推动产研融合发展，助力科研成果转化应用；
              通过卓越的教育资源整合、开创性的科研探索与高效的产业协同，全力塑造全方位的教育赋能生态体系，为培育顶尖专业人才、推动科研突破创新、促进产业升级变革持续注入核心动力，铸就全球教育与产业协同发展的卓越典范。
            </p>
          </div>
          <div className="intro-stats">
            <img 
              src="/20251104164215_148_163.png" 
              alt="业务线"
              style={{ width: '100%', maxWidth: '800px', height: 'auto', display: 'block' }}
            />
          </div>
        </section>
        <section className="cooperative-brands">
          <img
              src="/20251104164215_149_163.png"
              alt="服务体系线"
              style={{ width: '100%', maxWidth: '1160px', height: 'auto', display: 'block' }}
          />
        </section>
        <CooperativeBrands />
      </div>
    </div>
  );
};

export default AboutPage;
